import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Join from './pages/Join';
import Hrcom from './pages/Hrcom';
import Industry from './pages/Industry';
import Branding from './pages/Branding';
import TermsConditions from './pages/Terms_Condition';
import Privacy from './pages/Privacy';
import Refund from './pages/Refund';
import Ourteam from './pages/Ourteam';
import Ourpartner from './pages/Ourpartner';
import Joinmodel from './components/JoinModel';
import Eventpage from './pages/Eventpage';
import Eventform from './components/Event_form';
import Dashboard from './pages/dashboard';

import './App.css';

// Routes that should NOT show the site Header/Footer
const NO_LAYOUT_ROUTES = ['/dashboard'];

function AppContent() {
  const location = useLocation();
  const hideLayout = NO_LAYOUT_ROUTES.includes(location.pathname);

  return (
    <>
      {!hideLayout && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/join" element={<Join />} />
        <Route path="/hrcom" element={<Hrcom />} />
        <Route path="/industry" element={<Industry />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/ourteam" element={<Ourteam />} />
        <Route path="/ourpartner" element={<Ourpartner />} />
        <Route path="/joinmodel" element={<Joinmodel />} />
        <Route path="/eventspage" element={<Eventpage />} />
        <Route path="/eventform" element={<Eventform />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
      {!hideLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;